// extracted by mini-css-extract-plugin
export var originalPrice = "_um-0";